import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';

interface CompanyLogoBadgeProps {
  logoUrl?: string | null;
  companyName?: string | null;
  className?: string;
  altText?: string;
  variant?: 'dark-glass' | 'light-glass' | 'auto';
}

export const CompanyLogoBadge: React.FC<CompanyLogoBadgeProps> = ({
  logoUrl,
  companyName,
  altText = 'Company Logo',
}) => {
  const [imageError, setImageError] = useState(false);

  if (!logoUrl || imageError) {
    const displayName = companyName || 'HiAcuity';
    const initial = displayName.charAt(0).toUpperCase();

    return (
      <Box
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 1.5,
          px: 2,
          py: 1,
          borderRadius: '16px',
          bgcolor: '#0f172a',
          border: '1px solid rgba(255,255,255,0.1)',
          boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
        }}
      >
        <Box
          sx={{
            width: 32,
            height: 32,
            borderRadius: '10px',
            background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#ffffff',
            fontWeight: 700,
            fontSize: '1rem',
          }}
        >
          {initial}
        </Box>
        <Typography
          sx={{
            color: '#ffffff',
            fontWeight: 700,
            fontSize: '1rem',
            letterSpacing: '-0.01em',
          }}
        >
          {displayName}
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        maxWidth: 280,
        minWidth: 140,
        minHeight: 52,
        px: 2.5,
        py: 1.25,
        borderRadius: '16px',
        bgcolor: '#0f172a',
        border: '1px solid rgba(255,255,255,0.1)',
        boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
      }}
    >
      <Box
        component="img"
        src={logoUrl}
        alt={altText}
        onError={() => setImageError(true)}
        sx={{
          maxHeight: 40,
          width: 'auto',
          maxWidth: '100%',
          objectFit: 'contain',
        }}
      />
    </Box>
  );
};

